'use client';
import GallerySection from '@/components/sections/GallerySection';
import HeroBuilding from './Hero';
//* Styles
import BuildingsTemplateStyle from './style';
import Page from '@/components/common/Page';

const BuildingsTemplate = ({ pageData, floorData }) => {
	console.log(pageData);
	return (
		<Page className={'building'}>
			<BuildingsTemplateStyle>
				<HeroBuilding
					floorData={floorData.data}
					name={pageData.data.name.toUpperCase()}
					slug={pageData.data.slug}
					dataReady={pageData.data.year}
				/>

				{pageData.data.gallery.length ? <GallerySection items={pageData.data.gallery} title={pageData.data.blockTitle} description={pageData.data.blockDescription} /> : null}
			</BuildingsTemplateStyle>
		</Page>
	);
};

export default BuildingsTemplate;
